import React, { Component } from 'react';
import { IconButton, SvgImage } from '../../components';
import { addIcon, minusIcon } from '../../../style/images';
import { PropTypes } from 'prop-types';
import { translate } from '../../services';
import { identityState, combineStates, siteSettingsState } from '../../store';
import { connect } from 'react-redux';

export class WildArticleComponent extends Component {

  state = {
    enableSaveButton: false,
    warningMessage: null,
    wildArticles: [],
    emptyWildArticle: {
      code: "",
      productDescription: "",
      productPrice: "",
      invalidKeys: [],
    },
  }

  componentDidMount() {
    this.setState({
      wildArticles: [...this.props.wildArticles.map(x => ({
        code: x.code,
        productDescription: x.description,
        productPrice: x.netPrice,
        invalidKeys: [],
      })), { ...this.state.emptyWildArticle }]
    });
  }

  onChange = (index, key, e) => {
    let value = e.target.value;
    let data = [...this.state.wildArticles];
    let currentRow = { ...data[index] }; 
    let warningMessage = null;
    if (currentRow) {
      if (key === 'code') {
        if (!value?.includes('WA_')) value = 'WA_' + value;
      }

      currentRow[key] = value;
      if (this.validate(value, key)) {
        currentRow.invalidKeys = currentRow?.invalidKeys.filter(k => k !== key);
      } else if (currentRow?.invalidKeys?.indexOf(key) == -1) {
        currentRow['invalidKeys'] = [...currentRow['invalidKeys'], key];
        warningMessage = 'warning_message_' + key;
      }

      data[index] = { ...currentRow };
      this.setState({ wildArticles: data, warningMessage: warningMessage, enableSaveButton: true });
    }
  }

  addNewWildArticle = () => {
    let data = [...this.state.wildArticles, { ...this.state.emptyWildArticle }];
    this.setState({ wildArticles: data });
  }

  saveWildArticles = () => {
    let isInvalid = this.state.wildArticles.any(x => x.invalidKeys.length > 0)
    if (!isInvalid) {
      let data = this.state.wildArticles.map(x => {
        if (!x.code && !x.productDescription && !x.productPrice) {
          // empty row discarded automatically
          x.isInvalid = true;
        } else if (!x.code || !x.productDescription || !x.productPrice) {
          isInvalid = true;
          x.isInvalid = true;
        }
        if (!x.isInvalid) {
          let value = x.productPrice;
          if (isNaN(value)) {
            if (value.match(/\./g)?.length > 1) {
              value = value.replace(/\./g, "");
              value = value.replace(/,/g, ".");
            } else if (value.match(/\,/g)?.length > 1) {
              value = value.replace(/,/g, "");
            } else if (value.match(/\,/g)?.length) {
              value = value.replace(/,/g, ".");
            }
            x.netPrice = Number(value);
          } else x.netPrice = Number(value);
        }
        return x;
      })
      if (!isInvalid) {
        this.props.saveWildArticles(data.filter(x => !x.isInvalid));
        this.props.onClose && this.props.onClose();
        this.props.hidePopup();
      } 
    }
  }

  cancelPopup = () => {
    this.props.onClose && this.props.onClose();
    this.props.hidePopup();
  }

  validate(value, key) {
    let regEx = null;
    let isInvalid = false;
    if (key === 'code') {
      regEx = /^[A-Za-z\d_]*$/;
      if(this.state.wildArticles.find(w => w.key === value)) {
        isInvalid = true;
      }
    } else if (key === 'productPrice') {
      regEx = /(^\d+$)|(^(\d*[.]){0,}?(\d*[,]){0,1}?\d+$)|(^(\d*[,]){0,}?(\d*[.]){0,1}?\d+$)/;
    }
    if (regEx && regEx.test(value) && !isInvalid) {
      return true;
    } else return regEx ? false : true;
  }

  removeWildArticle(index) {
    let data = [...this.state.wildArticles];
    data.splice(index, 1);
    if (!data.length) {
      data = [{ ...this.state.emptyWildArticle }];
    }
    this.setState({ wildArticles: [...data], enableSaveButton: true });
  }

  getRows = (wildArticles) => {
    const className = "variable-input-field rw-widget-picker rw-input";
    return wildArticles.map((p, index) => {
      return <div className="row" key={index}>
        <div className="col-1" style={{ padding: "5px" }}>
          <div style={{ marginTop: "0.3em" }}>
            <SvgImage source={minusIcon} className="svg-icon" onClick={this.removeWildArticle.bind(this, index)} />
          </div>
        </div>
        <div className="col-3" style={{ padding: "5px",width: "145px" }}>
          <input type={'text'} className={className + (p.invalidKeys.indexOf('code') == -1 ? '' : ' invalid')} placeholder={translate('Product_ID')}
            value={p.code} onChange={e => this.onChange(index, 'code', e)} />
        </div>
        <div className="col-5" style={{ padding: "5px",width: "145px" }} >
          <input type={'text'} className={className} placeholder={translate('Description')}
            value={p.productDescription} onChange={e => this.onChange(index, 'productDescription', e)} />
        </div>
        <div className="col-3" style={{ padding: "5px",width: "145px" }}>
          <input type={'text'} className={className + (p.invalidKeys.indexOf('productPrice') == -1 ? '' : ' invalid')} placeholder={translate('LISTPRICE')}
            value={p.productPrice} onChange={e => this.onChange(index, 'productPrice', e)} />
        </div>
      </div>
    });
  }

  getWarningMessage = () => {
    let codes = this.state.wildArticles.map(w => w.code);
    let invalidKey = this.state.wildArticles.find(x => x.invalidKeys.length > 0)?.invalidKeys[0];
    return (codes.some((c, i) => codes.indexOf(c) != i) ? 'duplicate_product_codes' : this.state.warningMessage) ||
      (invalidKey ? 'warning_message_' + invalidKey : null);
  }

  getIncompleteRows = () => {
    return this.state.wildArticles.any(w => (!w.code || !w.productDescription || !w.productPrice) && !(!w.code && !w.productDescription && !w.productPrice));
  }

  render() {
    const { siteSettings, user } = this.props;
    const { wildArticles, enableSaveButton } = this.state;
    const warningMessage = this.getWarningMessage();
    const disableSaveBtn = warningMessage || !enableSaveButton || this.getIncompleteRows();
    let activeCurrency = siteSettings.currency || user.currency;
    if (siteSettings.isSpecificCurrencyRequired) {
      activeCurrency = siteSettings.specificCurrency.hasOwnProperty(user.country) ? siteSettings.specificCurrency[user.country] : siteSettings.specificCurrency['default'];
    }
    let currencyIcon = new Intl.NumberFormat(user.culture, { style: 'currency', currency: activeCurrency }).format(0)
    let rows = this.getRows(wildArticles, true);

    return <>
      <div style={{ padding: "15px" }}>
        <div className="row">
          <div className="col-1" style={{ padding: "5px" }}>
            <div style={{ marginTop: "0.2em" }}>
            <SvgImage source={addIcon} className="svg-icon" onClick={this.addNewWildArticle} />
            </div>
          </div>
          <div className="col-3 wildArticles_variable_header" style={{ padding: "5px",minWidth:"145px" }}>{translate('Product_ID')}</div>
          <div className="col-5 wildArticles_variable_header" style={{ padding: "5px",minWidth:"145px" }}>{translate('Description')}</div>
          <div className="col-3 wildArticles_variable_header" style={{ padding: "5px",minWidth:"145px" }}>{translate('LISTPRICE') + ' ( ' + currencyIcon[0] + ' )'}</div>
        </div>
        <div style={{ maxHeight: "300px", overflowX: "hidden", overflowY: "auto" }}>
          {rows}
        </div>
        <div className="row warning_message_wildArticles">
          {translate(warningMessage)}
        </div>
      </div>
      <div className="popup-header" style={{ width: "100%", justifyContent: "end" }}>
      <IconButton className="tertiary-button" text={"Cancel"} onClick={this.cancelPopup} />
        <IconButton disabled={disableSaveBtn} className="primary-button" text={"Save"} onClick={this.saveWildArticles} />
      </div>
    </>;
  }
}

WildArticleComponent.propTypes = {
  onClose: PropTypes.func,
  hidePopup: PropTypes.func,
};

export const WildArticle = connect(combineStates(identityState, siteSettingsState))(WildArticleComponent);